import { graphql } from '@/gql'

export const UpdateNoteMutation = graphql(/* GraphQL */ `
  mutation UpdateNoteMutation($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      ...NoteViewFragment
    }
  }
`)
